export default __webpack_public_path__ + "static/media/card-icon.2a7ee5d4.svg";